export default __webpack_public_path__ + "static/media/Tome of Deific Reverence.4d492bf2.jpg";